import { App } from 'vue'
import vDis from './src/dis.ts'

export default {
	install: (app: App) => {
		app.directive('dis', vDis)
	},
}

export { vDis }
